import { ElementRef } from '@angular/core'

export function toHTMLElement(ref: ElementRef<HTMLElement> | HTMLElement): HTMLElement {
  return ref instanceof HTMLElement ? ref : ref.nativeElement
}
